<template>
  <div v-if="previousWindowId" class="absolute bottom-4 left-4 z-50">
    <button
      type="button"
      @click="goToPrevious"
      class="previous-button flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg shadow-lg hover:bg-gray-700 transition-colors font-trebuchet-pixel text-sm"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
      <span>{{ $t('windows.tourGuide.previous') }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  currentWindowId: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['open-window', 'minimize-window'])

// Ordre des fenêtres dans le parcours guidé
const tourOrder = [
  'about',
  'academicPath',
  'competences',
  'activites',
  'reseau',
  'contact',
  'thankYou'
]

const previousWindowId = computed(() => {
  const currentIndex = tourOrder.indexOf(props.currentWindowId)
  if (currentIndex !== -1 && currentIndex > 0) {
    return tourOrder[currentIndex - 1]
  }
  return null
})

const goToPrevious = (event) => {
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  if (previousWindowId.value) {
    // Minimiser la fenêtre actuelle
    emit('minimize-window', props.currentWindowId)
    // Ouvrir la fenêtre précédente
    emit('open-window', previousWindowId.value)
  }
}
</script>

<style scoped>
/* Animation de pulsation pour le bouton précédent */
.previous-button {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(75, 85, 99, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(75, 85, 99, 0);
  }
}

.previous-button:hover {
  animation: none;
  transform: scale(1.05);
}
</style>

